var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{staticClass:"common-report customer-turnover-view"},[_c('customer-turnover-relation'),_c('customer-turnover-allocation')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }